import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import CoachTermsContent from './CoachTermsContent';
import './CoachTerms.css';

export default function CoachTerms() {
  return (
    <>
      <Header />

      <main className="coach-terms-page cd-page">
        <section className="cd-container">
          <div className="cd-tile">
            <div className="terms-container">
              <CoachTermsContent />

              <hr />

              <div className="back-to-top">
                <a href="#top" className="cd-link">Volver arriba ↑</a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
